import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Cookies from 'js-cookie';
import classnames from 'classnames';
import Button from 'helpers/Button';
import InputElement from 'ferries/helpers/InputElement';
import SocialAccount from 'User/Account/SocialAccount';
import LinkAccount from 'User/Account/LinkAccount';
import {validateLogin} from 'User/Account/validator';
import useAsync from 'User/helpers/hooks/useAsync';
import {loginUser} from 'providers/user/auth';
import {setUserLoggedinMessage} from 'utils/session';
import {boardingRoute, recoverPasswordRoute} from 'User/helpers/routes';
import {isProduction} from 'helpers/stableValues';
import eyeIcon from 'User/helpers/icons/eye.svg';
import eyeOffIcon from 'User/helpers/icons/eye-off.svg';
import {userAccountTranslations} from 'User/helpers/translations';

const nameEmail = 'username';
const namePassword = 'password';
const typeText = 'text';
const typePassword = 'password';
const {
  loginTitle, loginSubtitle, usingEmail, login, forgotPassword,
  notAccount, register, email: emailTr, password: passwordTr
} = userAccountTranslations;

const Login = ({isAccountPage, isModal, email: emailValue, onChangeTab}) => {
  const [email, setEmail] = useState({value: emailValue ?? '', error: []});
  const [password, setPassword] = useState({type: typePassword, value: '', error: []});
  const {isLoading, isSuccess, data, execute} = useAsync();

  useEffect(() => {
    if (isSuccess && data) {
      const {result: {uuid, session_token, refreshToken, email}} = data;
      localStorage.setItem('user', JSON.stringify({uuid, session_token, refreshToken, email}));
      Cookies.set(
        'user',
        JSON.stringify({uuid, session_token}),
        {path: '/', secure: isProduction, sameSite: 'lax'}
      );
      if (email) {
        const obfuscatedEmail = window.btoa(email?.trim().toLowerCase());
        window.braze?.changeUser(obfuscatedEmail);
      }
      Cookies.set(
        'TP24ID',
        session_token,
        {path: '/', secure: isProduction, sameSite: 'lax'}
      );

      setTimeout(() => {
        if (isAccountPage) {
          window.location = boardingRoute;
        }

        if (isModal) {
          setUserLoggedinMessage();
          location.reload();
        }
      }, 500);
    }
  }, [isSuccess, data, isAccountPage, isModal]);

  const tabRegister = () => onChangeTab(1);

  const onChangeInput = (field, value, name) => {
    if (name === nameEmail) {
      setEmail((prev) => ({...prev, value, error: []}));
    } else if (name === namePassword) {
      setPassword((prev) => ({...prev, value, error: []}));
    }
  };

  const onClickImg = () => {
    setPassword((prev) => ({
      ...prev,
      type: prev.type === typeText ? typePassword : typeText
    }));
  };

  const submit = async () => {
    const error = await validateLogin(email, password);
    if (error) {
      setEmail((prev) => ({...prev, error: error?.email ?? []}));
      setPassword((prev) => ({...prev, error: error?.password ?? []}));
    } else {
      await execute(loginUser({
        email: email.value,
        password: password.value,
        provider: 'brand',
        providerUserID: '',
        accessToken: ''
      }));
    }
  };

  const separatorClass = classnames('text-center', {
    'my-4': !isModal,
    'my-3': isModal
  });

  const forgotPasswordClass = classnames('d-block', {
    'mb-6': !isModal,
    'mb-3': isModal
  });

  return (
    <>
      <div className="display-4 font-bold">{loginTitle}</div>
      {!isModal && <div>{loginSubtitle}</div>}
      <SocialAccount
        isAccountPage={isAccountPage}
        isModal={isModal}
      />
      <div className={separatorClass}>{usingEmail}</div>
      <InputElement
        name={nameEmail}
        label={emailTr}
        field={email}
        inputProps={{className: 'lastpass user-login-btn'}}
        onChangeField={onChangeInput}
      />
      <InputElement
        name={namePassword}
        label={passwordTr}
        field={password}
        inputProps={{type: password.type, className: 'lastpass user-login-btn'}}
        image={{
          src: password.value ? (password.type === typeText ? eyeOffIcon : eyeIcon) : null,
          width: 16,
          height: 16,
          style: {
            top: '12px', right: '30px', backgroundColor: 'white',
            height: '90%', cursor: 'pointer'
          },
          onClick: onClickImg
        }}
        onChangeField={onChangeInput}
      />
      <Link
        to={recoverPasswordRoute}
        target="_blank"
        className={forgotPasswordClass}
      >
        {forgotPassword}
      </Link>
      <Button
        aria-label={login}
        status="primary"
        className="w-1-1"
        style={{height: '56px', borderRadius: '16px'}}
        isLoading={isLoading}
        disabled={isLoading}
        onClick={submit}
      >
        {login}
      </Button>
      <LinkAccount
        text={notAccount}
        label={register}
        onClick={tabRegister}
      />
    </>
  );
};

Login.propTypes = {
  isAccountPage: PropTypes.bool.isRequired,
  isModal: PropTypes.bool.isRequired,
  email: PropTypes.string,
  onChangeTab: PropTypes.func.isRequired
};

export default Login;
